/**
 * Mint a WhatsApp link code (block 24). Each call replaces the previous code.
 * Invalidates the list so a link made from the last code shows up.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useCreateLinkCode() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => getNookClient().createLinkCode(),
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.channels.all() });
        },
    });
}
//# sourceMappingURL=use-create-link-code.js.map